import { createApp } from 'vue'
import App from '@/App.vue';
import axios from 'axios';
import hub from '@/framework/hub/helpers/hub'
import router from '@/router';
import store from '@/generated/stores';
import vuetify from '@/plugins/vuetify';
// import vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import '@/style/main.css';
import '@/style/mobile.css';
import '@/style/svg.css';
import '@/style/module.css';
import '@/style/section.css';
import '@/style/treeview.css';
import '@/style/homepage.css';
import '@/style/list.css';
import '@/style/button.css';
import '@/style/searchInput.css';
import '@/style/icon.css';
import '@/style/filter.css';
import '@/style/input.css';
import '@/style/notification.css';
import '@/style/register.css';
import '@/style/FicheEtablissementAbstract.css';
import 'flag-icons/css/flag-icons.min.css';
import { MaskInput } from 'vue-3-mask';
import './date.extensions';
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

const app = createApp(App)
// Setup axios as the Vue default $http library
// app.prototype.$http = axios;
const api = axios.create({
    baseURL: import.meta.env.VITE_VUE_APP_SERVER_URL
})
app.config.globalProperties.$http = api;
store.dispatch('setConnexion', api);

// app.use(vuelidate);

const options = {
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ff7674',
};
app.use(VueSweetalert2, options);
app.directive('MaskInput', MaskInput);

const currentPath = window.location.pathname
    .replace(/\/{2,}/g, '/')
    .replace(/\/$/, '');
const isSignedPage = currentPath === '/signed';

if (store.getters.hubUsed && !isSignedPage) {
    app.use(hub);
}
app.use(router);
app.use(store);
app.use(vuetify);


app.mount('#app');
